import { Flex, Grid } from '@sequencehq/core-components'
import { Container } from 'components/NavigationV3/components/Container/Container'
import { Header } from 'components/NavigationV3/components/Header/Header'
import { Footer } from 'components/NavigationV3/components/Footer/Footer'
import { NavLinks } from 'components/NavigationV3/components/NavLinks/NavLinks'
import { IntegrationsNavigation } from 'modules/Integrations'
import { SavedViewsNavigation } from 'modules/SavedViews'
import { useKeyboardNavigation } from '../../lib/keyboardShortcuts/useKeyboardNavigation'
import { useNavigationV3Context } from './hooks/useNavigationV3Context'
import { useIsOnSettingsPage } from 'SettingsV2/settings.router'
import { SettingsNavLinks } from './components/NavLinks/SettingsNavLinks'
import { ProtectedComponent } from 'lib/rbac'

export const NavigationV3 = () => {
  useKeyboardNavigation()
  const { data } = useNavigationV3Context()
  // `isEffectivelyCollapsed` already accounts for the viewport (the mobile
  // slide-over drawer always shows the full nav regardless of the persisted
  // desktop-collapsed preference).
  const { isEffectivelyCollapsed: isCollapsed } = data
  const isOnSettingsPage = useIsOnSettingsPage()

  return (
    <Container>
      <Flex overflow="hidden" flex="1">
        <Grid
          height="100%"
          width="100%"
          gridTemplateColumns="100% 100%"
          transition="transform cubic-bezier(0.215, 0.61, 0.355, 1) 300ms"
          transform={`translateZ(0) ${isOnSettingsPage ? 'translateX(-100%)' : 'translateX(0%)'}`}
          willChange="transform"
        >
          <Flex
            direction="column"
            width="100%"
            justifyContent={'flex-start'}
            height="100%"
            opacity={isOnSettingsPage ? 0 : 1}
            transition="opacity 200ms ease-out, display 0ms linear 200ms"
            display={isOnSettingsPage ? 'none' : 'flex'}
            gridColumnStart="1"
            css={{ transitionBehavior: 'allow-discrete' }}
            overflow="hidden"
          >
            <Header />
            <Flex
              direction="column"
              width="100%"
              justifyContent={'flex-start'}
              height="100%"
              overflow={isCollapsed ? 'hidden' : 'auto'}
            >
              <NavLinks isCollapsed={isCollapsed} />
              <SavedViewsNavigation isCollapsed={isCollapsed} />
              <ProtectedComponent permission={'org.integration:update'}>
                <IntegrationsNavigation isCollapsed={isCollapsed} />
              </ProtectedComponent>
            </Flex>
          </Flex>

          <Flex
            gridColumnStart="2"
            direction="column"
            width="100%"
            justifyContent={'flex-start'}
            height="100%"
            opacity={isOnSettingsPage ? 1 : 0}
            display={isOnSettingsPage ? 'flex' : 'none'}
            transition="opacity 200ms ease-out, display 0ms linear 200ms"
            css={{
              transitionBehavior: 'allow-discrete'
            }}
          >
            <SettingsNavLinks isCollapsed={isCollapsed} />
          </Flex>
        </Grid>
      </Flex>
      <Footer />
    </Container>
  )
}
